import { render, staticRenderFns } from "./PdpTabCarTypes.vue?vue&type=template&id=05bbc6d5&scoped=true"
import script from "./PdpTabCarTypes.vue?vue&type=script&lang=js"
export * from "./PdpTabCarTypes.vue?vue&type=script&lang=js"
import style0 from "./PdpTabCarTypes.vue?vue&type=style&index=0&id=05bbc6d5&prod&scoped=true&lang=scss"
import style1 from "./PdpTabCarTypes.vue?vue&type=style&index=1&id=05bbc6d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbc6d5",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpdp-tab-car-types%2FPdpTabCarTypes.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports